import UserPlan, { UserPlanType } from '@creditflowresearch/user-plan/UserPlan';
import CheckUserAccess from '@/creditflowresearch/ui/common/components/CheckUserAccess';
import { useUserPlanContext } from '@/creditflowresearch/application/User/UserPlan/UserPlanContext';
import { UserPlanFeature } from '@creditflowresearch/user-plan/vo/IUserPlanResponse';
import { useParentPageContext } from '@/creditflowresearch/application/ParentPageContext';
import { StatsTileWithProvider } from '@/creditflowresearch/ui/components/creditFlow/Stats/StatsTile';
import { useAccessGrant } from '@/creditflowresearch/application/User/access/grants/useAccessGrant';
import StatsTileFallback from './StatsTileFallback';

interface IStatsTileWithFallbackProps {
  userAccessChecks: boolean[],
}

const StatsTileWithFallback = ({ userAccessChecks }: IStatsTileWithFallbackProps) => {
  const { checkAccessByUserPlan, checkAccessByFeature, plan } = useUserPlanContext();
  const { statsTileData } = useParentPageContext();
  const granted = useAccessGrant();

  const userAccessChecksExtended = granted
    ? [true]
    : [
      ...userAccessChecks,
      checkAccessByUserPlan(UserPlanType.PREMIUM),
      checkAccessByFeature(UserPlanFeature.NewIssueStats),
    ];

  return (
    <CheckUserAccess
      conditions={ [
        {
          checks: [granted || !UserPlan.isUnauthorized(plan)],
          fallback: <StatsTileFallback />,
        },
        {
          checks: userAccessChecksExtended,
          fallback: <StatsTileFallback isAuthorized />,
        },
      ] }
    >
      <StatsTileWithProvider initialData={ statsTileData } />
    </CheckUserAccess>
  );
};

export default StatsTileWithFallback;
